<template>
  <b-modal
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    body-class="py-5 bg-azul-claro text-center"
    header-class="border-0 pb-0"
    footer-class="justify-content-center gilmer"
    centered
    scrollable
    ref="my-modal"
  >
    <div slot="modal-title">
      <h5 class="gilmer text-uppercase font-weight-bold text-azul-medio h6">
        SISTEMA DE ADMISIÓN ESCOLAR
      </h5>
    </div>
    <div
      class="text-azul font-weight-bold gilmer h5 text-uppercase text-center"
    >
      <font-awesome-icon
        v-if="tipoModal === 'EXITO'"
        icon="check"
        class="text-azul mt-4 mr-2 text-success"
      />
      <font-awesome-icon
        v-else-if="tipoModal === 'ALERTA'"
        icon="exclamation-circle"
        class="text-azul mt-4 mr-2 text-warning"
      />
      <font-awesome-icon
        v-else-if="tipoModal === 'ERROR'"
        icon="times-circle"
        class="text-azul mt-4 mr-2 text-danger"
      />
      {{ tituloMensaje }}
    </div>
    <template v-if="mensaje.length === 3">
      <div class="text-justify">{{ mensaje[0] }}</div>
      <div v-for="sms in mensaje[1]" :key="sms.index">{{ sms }}</div>
      <br />
      <div>{{ mensaje[2] }}</div>
    </template>
    <template v-else>{{ mensaje }}</template>
    <p v-if="ayudaMieduc">
      Para mas información o solución de problemas dirígete a una oficina de
      <router-link
        data-testid="enlace-redireccion-ayuda"
        :to="{ name: 'AyudaRegional' }"
        >Ayuda Mineduc.</router-link
      >
    </p>
    <div
      slot="modal-footer"
      v-if="botoneraDoble"
      class="justify-content-center gilmer"
    >
      <router-link
        tag="button"
        data-testid="modal-enlace-redireccion-1"
        :to="{ name: 'Inicio' }"
        class="btn btn-gris-outline px-4 text-uppercase col-12 col-lg-auto mx-0 mx-lg-auto"
        >Iniciar sesión</router-link
      >
      <router-link
        tag="button"
        data-testid="modal-enlace-redireccion-2"
        :to="{ name: 'OlvidoContrasena' }"
        class="btn btn-azul-oscuro2 px-4 text-uppercase mt-0 mt-lg-0 col-12 col-lg-auto mx-0 mx-lg-auto mt-2 mt-lg-0"
        >Recuperar contraseña</router-link
      >
    </div>
    <div slot="modal-footer" v-else>
      <router-link
        data-testid="modal-enlace-redireccion"
        v-if="destino"
        :to="{ name: destino }"
        class="btn btn-azul-oscuro2 px-4 text-uppercase"
        >{{ textoBoton ? textoBoton : "Aceptar" }}</router-link
      >
      <button
        data-testid="modal-boton-ok"
        v-else
        class="btn btn-azul-oscuro2 px-4 text-uppercase"
        @click="hideModal"
      >
        {{ textoBoton ? textoBoton : "OK" }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faSms } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCheck);
library.add(faTimesCircle);
library.add(faExclamationCircle);
export default {
  props: [
    "mensaje",
    "tituloMensaje",
    "destino",
    "textoBoton",
    "tipoModal",
    "botoneraDoble",
    "ayudaMieduc"
  ],
  components: {
    FontAwesomeIcon
  },
  watch: {
    //Si cambiamos de pagina, cerramos el mensaje de carga
    $route: function() {
      this.hideModal();
    }
  },
  methods: {
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/modales/Mensaje.vue